import React from "react";
import { Handle, Position } from "reactflow";

import { ensureExtensionsStructure } from "./ensureExtensionsStructure";
import { ButtonDelete } from "../../../ButtonDelete";
import { useFlowNodes } from "../../../../context";
import { FormControlLabel, Switch } from "@material-ui/core";

import { Extensions } from "./components/Extensions";
import { addButtonExtension } from "../../../utils/addNode";
import { nodesExist } from "../../../utils/hasNodes";
import { handleExtensionIntentNode } from "../../../utils/removeDataNode";
import { typesNodes } from "../../../../types/nodeTypes/typesNodes";

import "./ExtensionConfigIntentNode.scss";

export const ExtensionConfigIntentNode = (props) => {
  const { id } = props;
  const { t, intent, updateIntent, updateElement, ...res } = useFlowNodes();
  const validatedExtensions = ensureExtensionsStructure(intent?.extensions);

  const isEnabledExtension = () => {
    if (intent?.responses.length > 1) {
      return true;
    } else return intent?.desks?.name;
  };


  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="extension-config-container">
        {intent?.extensions?.method && (
          <div className="extension-header-row">
            <span className="extension-title">
              {t("intents.config.accordion.extensions.switch")}
            </span>

            <FormControlLabel
              checked={intent?.extensions?.active || false}
              control={
                <Switch
                  disabled={isEnabledExtension()}
                  onClick={(e) => {
                    updateElement(e, "extensions_active", "bool");
                  }}
                  color="primary"
                />
              }
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
              label=""
            />

            <ButtonDelete
              setNodes={res.setNodes}
              setEdges={res.setEdges}
              nodeId={id}
              handleDelete={(e) => {
                handleExtensionIntentNode(updateIntent);

                addButtonExtension({
                  nodesExist: nodesExist({
                    nodes: res.nodes,
                    parentId: props.data.parentData.id,
                  }),
                  setNodes: res.setNodes,
                  setEdges: res.setEdges,
                  dataNode: props,
                  type: typesNodes.buttonAddExtension,
                  dataInfo: {
                    indexParam: res.variables.length - 1,
                  },
                });
              }}
            />
          </div>
        )}

        <Extensions
          {...res}
          intent={{ ...intent, extensions: validatedExtensions }}
          type="extensions"
          isFlow={true}
          updateIntent={updateIntent}
          t={t}
        />
      </div>
    </>
  );
};
